'use client'; 

import { partners } from "@/types/blog";
import Image from "next/image";
import { useRouter } from "next/navigation"; // Correct import for App Router

const SinglePartner = ({ blog }: { blog: partners }) => {
  const { title, image, designation } = blog;
  const router = useRouter();

  const handleClick = () => {
    router.push('/about');
  };

  return (
    <div
      onClick={handleClick}
      className="group relative h-full cursor-pointer overflow-hidden rounded-lg bg-white shadow-lg transition-all duration-500 hover:shadow-2xl dark:bg-gray-800"
    >
      {/* Image Container */}
      <div className="relative mx-auto px-8 pt-8">
        <div className="relative mx-auto h-64 w-64 overflow-hidden rounded-full bg-gray-100 ring-4 ring-gray-200 transition-all duration-300 group-hover:ring-primary dark:bg-gray-700 dark:ring-gray-600">
          <Image
            src={image}
            alt={title}
            fill
            className="object-cover transition-transform duration-500 group-hover:scale-110"
          />
        </div>
      </div>

      {/* Text Content - Centered */}
      <div className="px-6 pt-6 pb-10 text-center">
        <h3 className="font-playfair mb-2 text-2xl font-bold text-gray-900 transition-colors duration-300 group-hover:text-primary dark:text-white">
          {title}
        </h3>
        <span className="font-montserrat mb-2 text-l font-bold text-gray-900 transition-colors duration-300 group-hover:text-primary dark:text-white">
          {designation}
        </span>
      </div>

      {/* Subtle hover overlay */}
      <div className="pointer-events-none absolute inset-0 rounded-lg bg-gradient-to-t from-black/5 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
    </div>
  );
};

export default SinglePartner;